export default "__VITE_ASSET__d7c268a0__"